// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_cv-2";
export var aiChatCartContainerExit = "_cv-4";
export var aiChatContainerLarge = "_cv-0";
export var aiChatContainerSmall = "_cv-1";
export var aiChatIcon = "_cv-6";
export var slideInFromRight = "_cv-3";
export var slideOutToRight = "_cv-5";